const uri = window.location.href.split("?")[0];
var host = uri.substring(0, uri.indexOf('/', 8));
if (process.env.NODE_ENV !== 'production') {
  host = "https://gisdev1.odot.state.or.us";
}
//Need to update to arcgis113 at some point.
const webadaptor = "arcgis1006";

const env = {
  agsapi: host + "/Common/Libraries/arcgis_js_api/library/4.12/init.js",
  agsrestapi: host + "/" + webadaptor + "/rest/services",
  mapConfig: {
    basemapId: "0cbc1aba15014d7dbb1e79f1dbd2d2b6",
    options: {
      basemap: 'gray'
    },
    mapService: (host.indexOf("dev1") !== -1 || process.env.NODE_ENV !== 'production') ? '/tpt_dev/tpt_dev_display/MapServer/' : '/tpt/tpt_display/MapServer/',
    featureLayerIds: [1, 0, 2]
  },
  dataFetchQuery: "/query?where=1%3D1&geometryType=esriGeometryEnvelope&spatialRel=esriSpatialRelIntersects&outFields=*&returnGeometry=false&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&returnZ=false&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=pjson"
};

export default env;